import { MLDSA87DSWorker } from '../../worker_base/ds/ml';
import { workerHandler } from '../../../worker-handler/worker-handler';
import { WorkerOperation } from '../../../worker-handler/worker-common';

/**
 * Asymmetric signature with the ML-DSA-87 algorithm.
 */
export class MLDSA87DS extends MLDSA87DSWorker {
  public static sign(plain: Uint8Array, secret_key: Uint8Array): Promise<Uint8Array> {
    return workerHandler.run(WorkerOperation.MLDSA87DSSign, plain, secret_key);
  }

  public static verify(
    signature: Uint8Array,
    public_key: Uint8Array,
    plain: Uint8Array
  ): Promise<Uint8Array> {
    return workerHandler.run(WorkerOperation.MLDSA87DSVerify, signature, public_key, plain);
  }
}
